<tacho-page-header></tacho-page-header>
<div class="tacho-page">
	<div class="tacho-page-content-titles">
		<h1>{{'tachomat.goodbye-page.title.title-page' | translate}}</h1>
		<small>{{'tachomat.goodbye-page.title.title-info' | translate}}</small>
	</div>
	<tacho-data-loader imageSrc="assets/images/page-body/goodbye_page.svg"
					   [loading]="false"></tacho-data-loader>
</div>
<tacho-page-footer></tacho-page-footer>